module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"integrations":"Integrations","settings":"Settings","account":"Account","templates":"E-mail templates","payment":"Payment","users":"Users"}}')
  delete Component.options._Ctor
}
